__turbopack_context__.v({
  "actions": "photoUpload-module-scss-module__S64TNq__actions",
  "badgeDefaultIcon": "photoUpload-module-scss-module__S64TNq__badgeDefaultIcon",
  "badgeLoading": "photoUpload-module-scss-module__S64TNq__badgeLoading",
  "badgeRemoveButton": "photoUpload-module-scss-module__S64TNq__badgeRemoveButton",
  "badgeRoot": "photoUpload-module-scss-module__S64TNq__badgeRoot",
  "badgeRootSquare": "photoUpload-module-scss-module__S64TNq__badgeRootSquare",
  "badgeSpinner": "photoUpload-module-scss-module__S64TNq__badgeSpinner",
  "badgeText": "photoUpload-module-scss-module__S64TNq__badgeText",
  "badgeTextLink": "photoUpload-module-scss-module__S64TNq__badgeTextLink",
  "badgeUploadButton": "photoUpload-module-scss-module__S64TNq__badgeUploadButton",
  "badgeUploadIcon": "photoUpload-module-scss-module__S64TNq__badgeUploadIcon",
  "badgeUploader": "photoUpload-module-scss-module__S64TNq__badgeUploader",
  "badgeUploaderReadonly": "photoUpload-module-scss-module__S64TNq__badgeUploaderReadonly",
  "badgeUploaderSquare": "photoUpload-module-scss-module__S64TNq__badgeUploaderSquare",
  "boxButton": "photoUpload-module-scss-module__S64TNq__boxButton",
  "boxButtonIcon": "photoUpload-module-scss-module__S64TNq__boxButtonIcon",
  "boxButtonLabel": "photoUpload-module-scss-module__S64TNq__boxButtonLabel",
  "boxLoading": "photoUpload-module-scss-module__S64TNq__boxLoading",
  "boxPreview": "photoUpload-module-scss-module__S64TNq__boxPreview",
  "boxRemoveButton": "photoUpload-module-scss-module__S64TNq__boxRemoveButton",
  "boxRoot": "photoUpload-module-scss-module__S64TNq__boxRoot",
  "boxSpinner": "photoUpload-module-scss-module__S64TNq__boxSpinner",
  "boxUploadButton": "photoUpload-module-scss-module__S64TNq__boxUploadButton",
  "boxUploadIcon": "photoUpload-module-scss-module__S64TNq__boxUploadIcon",
  "checkboxRow": "photoUpload-module-scss-module__S64TNq__checkboxRow",
  "circleDefaultIcon": "photoUpload-module-scss-module__S64TNq__circleDefaultIcon",
  "circleImageWrapper": "photoUpload-module-scss-module__S64TNq__circleImageWrapper",
  "circleLoading": "photoUpload-module-scss-module__S64TNq__circleLoading",
  "circleRemoveButton": "photoUpload-module-scss-module__S64TNq__circleRemoveButton",
  "circleRoot": "photoUpload-module-scss-module__S64TNq__circleRoot",
  "circleSpinner": "photoUpload-module-scss-module__S64TNq__circleSpinner",
  "circleText": "photoUpload-module-scss-module__S64TNq__circleText",
  "circleTextLink": "photoUpload-module-scss-module__S64TNq__circleTextLink",
  "circleUploadButton": "photoUpload-module-scss-module__S64TNq__circleUploadButton",
  "circleUploadIcon": "photoUpload-module-scss-module__S64TNq__circleUploadIcon",
  "circleUploader": "photoUpload-module-scss-module__S64TNq__circleUploader",
  "circleUploaderReadonly": "photoUpload-module-scss-module__S64TNq__circleUploaderReadonly",
  "cropContainer": "photoUpload-module-scss-module__S64TNq__cropContainer",
  "cropControls": "photoUpload-module-scss-module__S64TNq__cropControls",
  "cropError": "photoUpload-module-scss-module__S64TNq__cropError",
  "error": "photoUpload-module-scss-module__S64TNq__error",
  "hiddenInput": "photoUpload-module-scss-module__S64TNq__hiddenInput",
  "hint": "photoUpload-module-scss-module__S64TNq__hint",
  "preview": "photoUpload-module-scss-module__S64TNq__preview",
  "previewRow": "photoUpload-module-scss-module__S64TNq__previewRow",
  "requiredAsterisk": "photoUpload-module-scss-module__S64TNq__requiredAsterisk",
  "root": "photoUpload-module-scss-module__S64TNq__root",
  "rotateBtn": "photoUpload-module-scss-module__S64TNq__rotateBtn",
  "rotateBtns": "photoUpload-module-scss-module__S64TNq__rotateBtns",
  "rotateLabel": "photoUpload-module-scss-module__S64TNq__rotateLabel",
  "rotateRow": "photoUpload-module-scss-module__S64TNq__rotateRow",
  "slider": "photoUpload-module-scss-module__S64TNq__slider",
  "sliderLabel": "photoUpload-module-scss-module__S64TNq__sliderLabel",
  "sliderRow": "photoUpload-module-scss-module__S64TNq__sliderRow",
  "spin": "photoUpload-module-scss-module__S64TNq__spin",
});
